import { Component } from '@angular/core';
import { SearchService } from '../../search/search.service';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { ModalService } from '../../services/modal.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { SearchCriteria, Condition, Clause } from '../../search/models/search-filter-model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchEvent } from '../../search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../search/search-constants';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { Subscription } from 'rxjs/Subscription';
import { CustomCellRendererComponent } from '../../components/custom-cell-renderer/custom-cell-renderer.component';

@Component({
  selector: 'lfwms-mbol-error-log-popup',
  templateUrl: './mbol-error-log-popup.component.html',
  styleUrls: ['./mbol-error-log-popup.component.css']
})
export class MbolErrorLogPopupComponent {
  public lookupSearchService: SearchService;
  public searchEventSubscription: Subscription;
  public resourceService: any;
  constructor(public modalService: ModalService,
    public coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry) {
    this.resourceService = this.coreServiceRegistry.resourceService;
  }
  public initializeComponents(mbolTableID: string, mbolKeys: string[]) {
    this.initializeLookupSearchContext(mbolTableID);
    this._doValidateMBOLAndGetResponseTableData(mbolKeys);
  }
  // initialize the table and search context
  public initializeLookupSearchContext(mbolTableID: string) {
    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = mbolTableID;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 15;
    // mbolKey is made as hyperlink to navigate to ship status error log
    searchParams.idProperty = 'mbolKey';
    /* Data editor is needed  for tableheader filter to work.
  Filter might misbehave if datatype is not set properly in metdata from db. */
    searchParams.tableEditor = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    // Client side pagination disabled
    searchParams.paginateLocally = true;
    const tableConfig: DataTableConfig = new DataTableConfig();
    //tableConfig.defaultCellRenderer = ReshipCellRendererComponent;
    tableConfig.enablePagination = true;
    tableConfig.enableFilter = true;
    tableConfig.columnRendererMapping['type'] = CustomCellRendererComponent;   
    tableConfig.specialWidthDetails = { messages: 350 };
    tableConfig.columnWidth = 150;
    tableConfig.cellStyle = {
      'white-space': 'normal',   // Allow text to wrap
      'overflow': 'visible',     // Ensure overflowing text is visible
      'text-overflow': 'clip',   // Disable ellipsis (...)
      'overflow-wrap': 'break-word'
    };
    tableConfig.autoHeight = true ;
    tableConfig.wrapText = true ;
    //tableConfig.showIdAsAHyperLink = true;
    searchParams.dataTableConfig = tableConfig;
    const searchStatus: SearchStatus = new SearchStatus();    
    this.lookupSearchService = this.sharedServiceRegistry.createSearchService(searchParams,
      searchStatus);
  }
  /*
  API call isp_ValidateMBOL and get response as loadBypage call.
    - clears the search criteria used for loadBypage request
      since it will conflict with logic for localpagination's paging, sort, filter etc.
  */
  private _doValidateMBOLAndGetResponseTableData(mbolKeys: string[]) {
    this.lookupSearchService.clearSearchStatus();
    /* above call required to clear of unexpected behaviour
   -not sending backend calls from second time when multiple parellel requests are sent */
    this.lookupSearchService.setSearchCriteria(this._getNewSearchCriteria(mbolKeys));
    // subscribe needed as we need to set mbolkey->warningNo mapping and clear search criteria;
    this.lookupSearchService.fetchSearchResults()
      .subscribe((data: any) => {
        this.lookupSearchService.searchStatus.hasResults = true;
        this.lookupSearchService.searchStatus.recordCount = this.lookupSearchService.pagedData.pageDefinition.recordCount;
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = true;
        this.lookupSearchService.publishEvent(event);
        // Clear search criteria to work with localPAgination
        this.lookupSearchService.setSearchCriteria(new SearchCriteria());
      });
  }
  /*
  Create custom search criteria for shipping wavekey/ multiple mbolkeys.
  wavekey value is also required even if mbolShip is done with values in mbolKeyList.
  ** (Custom loadByPage request manipulation is done at backend
    as a specific case for ship operation )
  */
  private _getNewSearchCriteria(mbolKeys: string[]) {
    const searchCriteria = new SearchCriteria();
    // Function snippet to reuse clause creation within this method
    const _createSearchClause = (columnName: string, value: any) => {
      const clause = new Clause();
      clause.operation = '=';
      clause.column = columnName;
      clause.value = value;
      clause.logicalOperation = 'OR';
      return clause;
    };
    // Create a search condition and set its properties
    const searchCondition = new Condition();
    searchCondition.isMandatory = true;
    searchCondition.operator = 'OR';
    searchCondition.clauses = [];
    // Iterate through each mbolKey and add a clause for it
    mbolKeys.forEach((mbolKey) => {
      const newClause = _createSearchClause('mbolKey', mbolKey);
      searchCondition.clauses.push(newClause);
    });
    searchCriteria.conditions.push(searchCondition);
    return searchCriteria;
  }
  public ngOnDestroy() {
    if (this.searchEventSubscription) {
      this.searchEventSubscription.unsubscribe();
    }
  }
}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/mbol-error-log-popup/mbol-error-log-popup.component.ts